import { BaseService } from "./BaseService";
import { Measures } from "../types/app.interfaces";
import { FunctionGroup, MeasuresType } from "../types/app.enums";

export class PooledBenchmarkService extends BaseService {
  burgissCalcPooledBenchmarkIRR(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    startDate?: any,
    requireReportedValuation?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        startDate,
        requireReportedValuation,
        alternateCurrrency,
        investId,
        [],
        MeasuresType.IRR,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkIRR",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmark
      );
    } else if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        startDate,
        requireReportedValuation,
        alternateCurrrency,
        [],
        [],
        MeasuresType.IRR,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkIRR",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmark
      );
    }
    return null;
  }
  burgissCalcPooledBenchmarkTWRR(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    startDate?: any,
    requireReportedValuation?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string,
    dynamicParameter?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        startDate,
        requireReportedValuation,
        alternateCurrrency,
        investId,
        [],
        MeasuresType.TWRR,
        uniqueCellId,
        dynamicParameter
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkTWRR",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmark
      );
    } else if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        idType,
        selectionSetId,
        weightingMethod,
        filter,
        currency,
        startDate,
        requireReportedValuation,
        alternateCurrrency,
        [],
        [],
        MeasuresType.TWRR,
        uniqueCellId,
        dynamicParameter
      );
      return super._pushOperation(
        "BurgissCalcPooledBenchmarkTWRR",
        objRequest,
        this.APICONFIG.GETPOOLEDBENCH,
        FunctionGroup.Pooledbenchmark
      );
    }
    return null;
  }
  createPayload(
    investId: any[][] = null,
    endDate: any = null,
    idType: string = null,
    selectionSetId: any = null,
    weightingMethod: any = null,
    filter: any = "",
    currency: string = null,
    beginDate: any = null,
    requireReportedValuation: any = null,
    alternateCurrrency: string = null,
    portfolioId: any[][] = null,
    assetId: any[][] = null,
    measure: string = null,
    alias: string = null,
    dynamicParameter: any = null
  ) {
    const measuresObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      portfolioID: String(portfolioId).toUpperCase() == "ALL" ? "-1" : String(portfolioId),
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(currency).toLowerCase() === "true",
      alternateBaseCurrency: alternateCurrrency,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: beginDate,
      endDate: endDate,
      year: null,
      indexID: null,
      premium: null,
      idType: idType,
      selectionsetID: selectionSetId,
      assetID: String(assetId).toUpperCase() == "ALL" ? "-1" : String(assetId),
      weightingMethod: weightingMethod,
      value: null,
      filter: filter,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: requireReportedValuation,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: dynamicParameter,
      universe: null,
      weight: null,
      commitment: null,
    };
    return measuresObject;
  }
}
